module.exports = __webpack_public_path__ + "static/media/Galactic.992453a1.webp";